import {DataLoader} from '@wallaby-ui/core';
import React from 'react';

import {useLoadAgens} from '../hooks';

interface OwnProps extends DataLoader {}
type Props = OwnProps;

export const AgensLoader: React.FC<Props> = (props) => {
  const {apiUrl, children} = props;

  const {isLoading, error} = useLoadAgens(apiUrl);

  return isLoading || error ? null : <>{children}</>;
};

AgensLoader.displayName = 'AgensLoader';
